(function () {
  'use strict';
  if (customElements.get('mm-cart-preview')) return;

  var HEX = /^#(?:[a-f\d]{3}|[a-f\d]{6})$/i;
  var mediaCache = null;

  function safeURL(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      var url = new URL(value, window.location.href);
      if (url.origin === window.location.origin) return url.href;
      if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com'))) return url.href;
      return null;
    } catch (e) {
      return null;
    }
  }

  function loadMedia(src) {
    if (mediaCache) return mediaCache;
    var url = safeURL(src);
    if (!url) return Promise.reject(new Error('Invalid media URL'));
    mediaCache = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Media asset unavailable');
      return r.json();
    });
    return mediaCache;
  }

  class MMCartPreview extends HTMLElement {
    connectedCallback() {
      if (this.rendered) return;
      this.rendered = true;

      var options;
      try {
        options = JSON.parse(this.dataset.mmOptions || '[]');
      } catch (e) {
        return;
      }
      if (!Array.isArray(options) || options.length < 2) return;
      if (!options.every(function (v) { return typeof v === 'string' && v; })) return;

      var img = this.querySelector('img');
      if (!img) return;

      var self = this;
      loadMedia(this.dataset.mmMediaUrl).then(function (media) {
        if (!self.isConnected) return;
        var photo = safeURL(media.previews && media.previews[JSON.stringify(options)]);
        if (photo) {
          self.setPhoto(img, photo, options.join(' / '));
        } else {
          self.setDigital(img, media, options);
        }
      }).catch(function () {});
    }

    setPhoto(img, url, alt) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
      img.alt = alt;
    }

    setDigital(img, media, options) {
      var icon = safeURL(media.patternIcons && media.patternIcons[options[0]]);
      var background = media.backgroundSwatches && media.backgroundSwatches[options[1]];
      var frame = options[2] ? media.frameSwatches && media.frameSwatches[options[2]] : null;
      if (!icon || !HEX.test(background || '')) return;
      if (options[2] && !HEX.test(frame || '')) return;

      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = icon;
      img.alt = options.join(' / ');
      img.style.boxSizing = 'border-box';
      img.style.objectFit = 'contain';
      img.style.backgroundColor = background;
      img.style.padding = frame ? '13%' : '17%';
      if (frame) img.style.border = '7px solid ' + frame;
    }
  }

  customElements.define('mm-cart-preview', MMCartPreview);
})();
